export default function initializeLanguageSelector() {
  const desktopLangToggle = document.getElementById("language-toggle");
  const desktopLangDropdown = document.querySelector(".language-dropdown");
  const langArrow = document.querySelector("#language-toggle .lang-arrow"); // More specific selector
  const currentLangDisplayDesktop = document.querySelector(
    "#language-toggle .current-lang"
  );
  const allLangOptions = document.querySelectorAll(".lang-option"); // Selects both desktop and mobile options

  // Get default language from PHP (localized), fallback to 'tr' if not available
  const serverDefaultLang =
    window.wpVars && window.wpVars.defaultLang
      ? window.wpVars.defaultLang
      : "tr";

  // Determine initial language: 1. Cookie, 2. Server-determined default
  let currentSelectedLang = serverDefaultLang; // Start with server default
  const cookieLang = document.cookie
    .split("; ")
    .find((row) => row.startsWith("site_lang="))
    ?.split("=")[1];

  if (cookieLang && (cookieLang === "tr" || cookieLang === "en")) {
    currentSelectedLang = cookieLang;
  }
  // If no cookie, currentSelectedLang remains serverDefaultLang

  // Update UI to match current/determined language
  function updateUIDisplays(lang) {
    if (currentLangDisplayDesktop) {
      currentLangDisplayDesktop.textContent = lang.toUpperCase();
    }
    allLangOptions.forEach((option) => {
      option.classList.toggle("active", option.dataset.lang === lang);
    });
  }

  updateUIDisplays(currentSelectedLang);

  // Store in localStorage for potential other JS module use (optional, cookie is primary)
  localStorage.setItem("selectedLanguage", currentSelectedLang);

  // Desktop dropdown functionality
  if (desktopLangToggle && desktopLangDropdown) {
    desktopLangToggle.addEventListener("click", (e) => {
      e.stopPropagation(); // Prevent closing immediately due to document click listener
      const isShown = desktopLangDropdown.classList.toggle("show");
      if (langArrow) langArrow.classList.toggle("active", isShown);
    });

    // Close dropdown when clicking outside
    document.addEventListener("click", (e) => {
      if (
        desktopLangDropdown.classList.contains("show") &&
        !desktopLangToggle.contains(e.target) &&
        !desktopLangDropdown.contains(e.target)
      ) {
        desktopLangDropdown.classList.remove("show");
        if (langArrow) langArrow.classList.remove("active");
      }
    });
  }

  // Language selection handler (for all .lang-option elements)
  allLangOptions.forEach((option) => {
    option.addEventListener("click", (e) => {
      e.preventDefault();
      const newLang = option.dataset.lang;

      if (newLang === currentSelectedLang) {
        // If already selected, just close dropdowns if open
        if (
          desktopLangDropdown &&
          desktopLangDropdown.classList.contains("show")
        ) {
          desktopLangDropdown.classList.remove("show");
          if (langArrow) langArrow.classList.remove("active");
        }
        const narrowSubMenu = document.querySelector(".narrow-submenu");
        if (
          narrowSubMenu &&
          narrowSubMenu.classList.contains("show") &&
          e.target.closest(".narrow-language-options")
        ) {
          narrowSubMenu.classList.remove("show");
          const menuBtn = document.querySelector("#menu-toggle");
          if (menuBtn) menuBtn.classList.remove("active"); // Assuming 'active' class on hamburger
          const overlay = document.querySelector(".overlay");
          if (overlay) {
            overlay.classList.remove("show");
            overlay.classList.add("hide");
          }
        }
        return; // No change, do nothing else
      }

      // Update UI immediately
      updateUIDisplays(newLang);
      currentSelectedLang = newLang; // Update internal state
      localStorage.setItem("selectedLanguage", newLang);

      // Close desktop dropdown if it's open
      if (
        desktopLangDropdown &&
        desktopLangDropdown.classList.contains("show")
      ) {
        desktopLangDropdown.classList.remove("show");
        if (langArrow) langArrow.classList.remove("active");
      }

      // Close narrow submenu if a language option within it was clicked
      const narrowSubMenu = document.querySelector(".narrow-submenu");
      const menuBtn = document.querySelector("#menu-toggle"); // For hamburger icon
      const overlay = document.querySelector(".overlay");

      if (
        narrowSubMenu &&
        narrowSubMenu.classList.contains("show") &&
        e.target.closest(".narrow-language-options")
      ) {
        narrowSubMenu.classList.remove("show");
        narrowSubMenu.classList.add("hide"); // Ensure it's hidden visually
        if (menuBtn) menuBtn.classList.remove("active"); // Deactivate hamburger
        if (overlay) {
          overlay.classList.remove("show");
          overlay.classList.add("hide");
        }
      }

      // Disable button to prevent multiple clicks while processing
      option.style.pointerEvents = "none";
      option.style.opacity = "0.7";

      // Send AJAX request to update language preference on the server
      if (window.wpVars && window.wpVars.ajaxUrl && window.wpVars.nonce) {
        fetch(window.wpVars.ajaxUrl, {
          method: "POST",
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
          body: new URLSearchParams({
            action: "update_language",
            lang: newLang,
            nonce: window.wpVars.nonce,
          }),
        })
          .then((response) => {
            if (!response.ok) {
              throw new Error(`HTTP error! status: ${response.status}`);
            }
            return response.json();
          })
          .then((data) => {
            if (data.success) {
              window.location.reload(); // Reload the page to reflect new language
            } else {
              console.error("Failed to update language on server:", data);
              // Re-enable button on error
              option.style.pointerEvents = "auto";
              option.style.opacity = "1";
            }
          })
          .catch((error) => {
            console.error("Error updating language via AJAX:", error);
            // Re-enable button on error
            option.style.pointerEvents = "auto";
            option.style.opacity = "1";
          });
      } else {
        console.error(
          "wpVars not defined or missing ajaxUrl/nonce for language update."
        );
        // Re-enable button if wpVars are missing
        option.style.pointerEvents = "auto";
        option.style.opacity = "1";
      }
    });
  });
}
